export default __webpack_public_path__ + "static/media/Anon-IAMA.edacc47d.png";